import LargeItemCard from "./base/LargeItemCard.jsx";
import Button from "./base/Button.jsx";
import { useNavigate } from "react-router-dom";

export default function PriceItem({ price, race }) {
   
const navigate = useNavigate();

  const onClick = () => {
    navigate(`${price.id_bdd}/register`);
  }

  const isRaceInactive = race && race.active === false;

  return(
        <LargeItemCard justify={true}>
            <div>
              <p style={styles.ticketName}>{price.name}</p>
              <p style={styles.ticketPrice}>{price.price} €</p>
            </div>
            {isRaceInactive ? (
              <span style={styles.inactiveStatus}>
                Course Inactive
              </span>
            ) : price.available > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
              <Button title="Réserver" onClick={onClick} width={"auto"} />
              <p style={styles.remainingTickets}>{price.available} dossards restants</p>
            </div>
            ) 
            :(
            <span style={styles.ticketStatus}>
              Complet
            </span>)
            }
        </LargeItemCard>
    );
}

const styles = {
  ticketName: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#1a1a1a",
    margin: "0 0 4px 0",
  },
  ticketPrice: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#1a1a1a",
    margin: 0,
  },
  ticketStatus: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#4CAF50",
    backgroundColor: "#e8f5e9",
    padding: "4px 12px",
    borderRadius: "16px",
  },
  inactiveStatus: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#999",
    backgroundColor: "#f5f5f5",
    padding: "4px 12px",
    borderRadius: "16px",
  },
  remainingTickets: {
    fontSize: "12px",
    fontStyle: "italic",
    color: "#666",
    margin: 0,
  },
};